import React from "react";

const Title = ({ text }) => {
  return <h1 className="text-5xl font-bold">{text}</h1>;
};

export { Title };
